import { StyleSheet } from "react-native";

const CONTENT_MAX_WIDTH = 1796;
const FORM_WIDTH = 762;
const FORM_INNER_WIDTH = 682;
const GRID_WIDTH = 1293;
const MOBILE_CONTENT_WIDTH = 375;

export const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: "#f6f7f9",
  },
  scrollContent: {
    flexGrow: 1,
  },
  content: {
    width: "100%",
    alignItems: "center",
    alignSelf: "center",
  },
  contentDesktop: {
    width: "100%",
    maxWidth: CONTENT_MAX_WIDTH,
    paddingHorizontal: 40,
    paddingTop: 24,
    paddingBottom: 32,
  },
  contentMobile: {
    width: "100%",
    maxWidth: MOBILE_CONTENT_WIDTH,
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 24,
  },
  mainContent: {
    width: "100%",
    alignItems: "center",
  },
  pageTitle: {
    fontSize: 36,
    fontWeight: "700",
    fontFamily: "LexendBold",
    color: "#2b2b2f",
    textAlign: "center",
    letterSpacing: -1,
    marginTop: 16,
    marginBottom: 8,
  },
  pageTitleMobile: {
    fontSize: 26,
    lineHeight: 28,
    letterSpacing: -0.4,
    marginTop: 8,
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    lineHeight: 22,
    fontFamily: "Lexend",
    color: "#6e6e6e",
    textAlign: "center",
    marginBottom: 24,
  },
  subtitleMobile: {
    fontSize: 14,
    lineHeight: 20,
    marginBottom: 16,
  },
  formCard: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 32,
    borderWidth: 1,
    borderColor: "#d8dbe1",
    width: FORM_WIDTH,
  },
  formCardMobile: {
    width: "100%",
    maxWidth: 343,
    paddingVertical: 24,
    paddingHorizontal: 16,
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 14,
    fontWeight: "700",
    fontFamily: "LexendBold",
    color: "#2b2b2f",
    marginBottom: 10,
    textTransform: "uppercase",
  },
  input: {
    height: 44,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#ddd",
    paddingHorizontal: 12,
    backgroundColor: "#fff",
    fontSize: 16,
    fontFamily: "Lexend",
    color: "#333",
    width: FORM_INNER_WIDTH,
  },
  inputMobile: {
    width: "100%",
    maxWidth: 311,
    paddingHorizontal: 12,
    alignSelf: "center",
  },
  inputFocused: {
    borderColor: "#3a6fb1",
  },
  inputError: {
    borderColor: "#e53e3e",
    borderWidth: 1,
  },
  errorText: {
    color: "#e53e3e",
    fontSize: 12,
    marginTop: 6,
    fontWeight: "500",
  },
  helperText: {
    marginTop: 8,
    color: "#8f8f8f",
    fontSize: 12,
    fontFamily: "Lexend",
  },
  helperTextMobile: {
    marginTop: 12,
  },
  topicsSection: {
    width: "100%",
    marginTop: 32,
    alignItems: "center",
  },
  topicsGridContainer: {
    width: "100%",
    maxWidth: GRID_WIDTH,
    alignSelf: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    paddingHorizontal: 8,
    gap: 24,
  },
  topicsGridContainerMobile: {
    maxWidth: "100%",
    flexDirection: "column",
    alignItems: "center",
    paddingHorizontal: 0,
    gap: 24,
  },
  customBox: {
    width: "100%",
    maxWidth: FORM_WIDTH,
    marginTop: 16,
    backgroundColor: "#fff",
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#d8dbe1",
    padding: 24,
  },
  customBoxMobile: {
    maxWidth: 343,
    padding: 16,
  },
  customLabel: {
    fontSize: 14,
    fontFamily: "LexendBold",
    color: "#2b2b2f",
    marginBottom: 10,
  },
  footerSection: {
    width: "100%",
    alignItems: "center",
    paddingVertical: 24,
  },
  footerSectionMobile: {
    paddingTop: 16,
    paddingBottom: 32,
  },
  footer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: 24,
    paddingVertical: 12,
    backgroundColor: "transparent",
  },
  footerMobile: {
    width: "100%",
    maxWidth: 343,
    paddingVertical: 0,
  },
  cancelButton: {
    height: 62,
    minWidth: 259,
    paddingHorizontal: 20,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#d8dbe1",
    backgroundColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },
  cancelButtonMobile: {
    flex: 1,
    minWidth: 130,
    maxWidth: 159.5,
    paddingHorizontal: 4,
  },
  cancelButtonText: {
    fontSize: 14,
    fontWeight: "700",
    fontFamily: "LexendBold",
    color: "#2b2b2f",
    textTransform: "uppercase",
  },
  continueButton: {
    height: 62,
    minWidth: 259,
    paddingHorizontal: 20,
    borderRadius: 16,
    backgroundColor: "#3a6fb1",
    alignItems: "center",
    justifyContent: "center",
  },
  continueButtonMobile: {
    flex: 1,
    minWidth: 130,
    maxWidth: 159.5,
    paddingHorizontal: 4,
  },
  continueButtonDisabled: {
    backgroundColor: "#ccc",
    opacity: 0.6,
  },
  continueButtonText: {
    fontSize: 14,
    fontWeight: "700",
    fontFamily: "LexendBold",
    color: "#fff",
    textTransform: "uppercase",
  },
});
